<div id="feedback-widget" class="container wrapper feedback-component">
    <feedback-webcomponent product="OwnerDashboard" telephonemode="false" show-support-teaser="false"></feedback-webcomponent>
</div>
<div class="container wrapper">
    <app-footnote></app-footnote>
</div>

<app-alertbox-fixed alertKey="OFFLINE_ERROR" *ngIf="!appIsOnline"></app-alertbox-fixed>
